import { Col, Divider, Input, Row, Slider, Switch, Tooltip, Typography } from 'antd';
import { SenseMode } from '../../../types/types';

type MeasurementParametersProps = {
  senseMode: SenseMode;

  // Auto-save measurement
  isAutoSavedMeasurementEnabled: boolean;
  setIsAutoSavedMeasurementEnabled: React.Dispatch<React.SetStateAction<boolean>>;

  // Humidity calibrant
  isRecordingCalibrantEnabled: boolean;
  setIsRecordingCalibrantEnabled: React.Dispatch<React.SetStateAction<boolean>>;

  // Measurement metadata
  measurementName: string;
  setMeasurementName: React.Dispatch<React.SetStateAction<string>>;

  descriptionName: string;
  setDescriptionName: React.Dispatch<React.SetStateAction<string>>;

  // Multiplicator factor
  multiplicatorFactor: number;
  setMultiplicatorFactor: React.Dispatch<React.SetStateAction<number>>;
};

const MULTIPLICATOR_FACTOR_TOOLTIP = 'When correcting signal, the raw value is scaled with this factor from 0 to 10 on a scale. Value 1 has no correction whereas multiplying the residuals makes sense depending on the use case.';

const MeasurementParameters: React.FC<MeasurementParametersProps> = ({
  senseMode,
  isAutoSavedMeasurementEnabled,
  setIsAutoSavedMeasurementEnabled,
  measurementName,
  setMeasurementName,
  descriptionName,
  setDescriptionName,
  isRecordingCalibrantEnabled,
  setIsRecordingCalibrantEnabled,
  multiplicatorFactor,
  setMultiplicatorFactor,
}) => {
  return (
    <>
      <Typography.Title level={5}>Measurement Settings</Typography.Title>
      <Row gutter={[16, 16]}>
        {senseMode === SenseMode.TimedRecording && (
          <>
            <Col span={12}>
              <Typography.Text>Measurement name</Typography.Text>
              <Input value={measurementName} onChange={(e) => setMeasurementName(e.target.value)} placeholder="Enter measurement name" />
            </Col>
            <Col span={12}>
              <Typography.Text>Description</Typography.Text>
              <Input value={descriptionName} onChange={(e) => setDescriptionName(e.target.value)} placeholder="Enter description" />
            </Col>
          </>
        )}
        <Col span={24}>
          <Typography.Text>Auto-save measurement to cloud database</Typography.Text>
          <div style={{ marginTop: 8 }}>
            <Switch checked={isAutoSavedMeasurementEnabled} onChange={setIsAutoSavedMeasurementEnabled} />
          </div>
        </Col>
        <Col span={24}>
          <Typography.Text>Is that record a calibrant ?</Typography.Text>
          <div style={{ marginTop: 8 }}>
            <Switch checked={isRecordingCalibrantEnabled} onChange={setIsRecordingCalibrantEnabled} />
          </div>
        </Col>
        <Col span={24}>
          <Tooltip title={MULTIPLICATOR_FACTOR_TOOLTIP}>
            <Typography.Text>Multiplicator factor</Typography.Text>
          </Tooltip>
          <Slider min={1} max={5} step={0.5} value={multiplicatorFactor} onChange={(value) => setMultiplicatorFactor(value as number)} marks={{ 1: '1', 2: '2', 3: '3', 4: '4', 5: '5' }} tooltip={{ formatter: (value) => `${value}x` }} />
        </Col>
      </Row>
      <Divider />
    </>
  );
};

export default MeasurementParameters;
